import React from 'react';
import './help-icon.css';
import { useNavigate } from 'react-router-dom';
import { makeId } from '../../../../utils';
import { Tooltip } from '@mui/material';
import { EditorService } from '../../../../services/editor';

interface IHelpIconButtonProps {
	project: EditorService;
	article: string;
	tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
}

const HelpIconButton: React.FC<IHelpIconButtonProps> = ({
	article,
	tooltipPlacement = 'top',
	project,
}) => {
	const relativeURL = `${project?.editorBasePath}/help/${article}`;
	const id = makeId();
	const navigate = useNavigate();

	const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.preventDefault();
		e.stopPropagation();
		navigate(relativeURL);
	};

	return (
		<a href={relativeURL} onClick={handleClick} className='help-icon-button'>
			<Tooltip
				title={`Click to navigate to the help article.`}
				placement={tooltipPlacement}
			>
				<i id={id} className='fa-regular fa-question-circle' />
			</Tooltip>
		</a>
	);
};

export default HelpIconButton;
